let domainId = process.env.REACT_APP_DOMAIN || null;
let locationId = process.env.REACT_APP_LOCATION || null;

export const getDomainId = () => domainId;

export const setDomainId = (id) => {
	domainId = id;
};

export const getLocationId = () => locationId;

export const setLocationId = (id) => {
	locationId = id;
};

export const getApiUrl = () => process.env.REACT_APP_API;

export const getBaseUrl = () => process.env.REACT_APP_BASE_URL || window.location.origin;

export const isDevOverride = () => !!process.env.REACT_APP_DOMAIN;
